import type * as AddVoucher from '@ori-events/add-voucher';
import * as AddVoucherFailed from '@ori-events/add-voucher-failed';
import type { PositionData } from '@ori/analytics-data';

import type { AddVoucherResponse } from '../guards/addVoucherResponse';
import {
  isAddVoucherSuccessResponse,
  isAddVoucherErrorResponse,
} from '../guards/addVoucherResponse';
import { convertToCamelCase, getHttpRequestSettings } from '../helpers';
import { RequestUrl } from '../models';

interface Data extends AddVoucher.Data, PositionData {}

const dispatchAddVoucherFailed = (detail: AddVoucherFailed.Data) => {
  const event = new CustomEvent<AddVoucherFailed.Data>(AddVoucherFailed.Name, {
    detail,
  });
  window.dispatchEvent(event);
};

export default async ({ detail: { placement, voucherCode } }: CustomEvent<Data>) => {
  const fetchUrl = `${RequestUrl.AddVoucher}?voucherCode=${voucherCode}`;
  const request = await fetch(fetchUrl, getHttpRequestSettings({ placement }));

  const response = convertToCamelCase<AddVoucherResponse>((await request.json()) as object);

  if (isAddVoucherSuccessResponse(response)) {
    return response;
  }

  if (isAddVoucherErrorResponse(response)) {
    dispatchAddVoucherFailed(response);
  }

  return false;
};
